import React from 'react'
import { compose } from 'recompose'
import { withStoreTemplatesState } from 'store/storeTemplates/storeTemplateHocs'
import { Grid } from 'semantic-ui-react'
import IconCard from 'components/Card/IconCard'

const StoreTemplates = compose(
  withStoreTemplatesState(),
)(
  ({
    storeTemplates,
    currentTemplate,
    onSelectTemplate,
    getStoreTemplateIcon,
  }) => {
    return (
      <Grid style={{ marginTop: 20 }}>
        {storeTemplates.map((template) => {
          const { id, refTemplate, name } = template
          const isActive = (
            currentTemplate && currentTemplate.id === id
          )
          return (
            <Grid.Column width={3} key={id}>
              <IconCard
                icon={getStoreTemplateIcon(refTemplate)}
                onClick={() => onSelectTemplate(template)}
                isActive={isActive}
                caption={name}
              />
            </Grid.Column>
          )
        })}
      </Grid>
    )
  }
)

StoreTemplates.propTypes = {}
StoreTemplates.defaultProps = {}

export default StoreTemplates



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/selectors/StoreTemplates.js